import React from "react";
import { Context, createContext, PropsWithChildren, useState } from "react";
import ParkingToolSpace from "./ParkingToolTypes";

// interface ICreateDamageFormContext {
//   generalInfo?: CreateDamageFormTypes.IGeneralInfo;

//   setGeneralInfo: (val: CreateDamageFormTypes.IGeneralInfo) => void;
// }

interface IParkingToolContext {
  tenant?: string;
  setTenant: (val: string) => void;
  request?: ParkingToolSpace.Request; 
  setRequest: (val: ParkingToolSpace.Request) => void;
}

export const ContextParkingTool: Context<IParkingToolContext> = createContext<IParkingToolContext>({
  setTenant: () => {},
  setRequest: () => {},
});

export const ProviderParkingTool = (props: PropsWithChildren<any>) => {
  const [tenant, setTenant] = React.useState<string | undefined>();
  const [request, setRequest] = React.useState<ParkingToolSpace.Request | undefined>();

  return (
    <ContextParkingTool.Provider
      value={{
        tenant,
        setTenant,
        request,
        setRequest
      }}
    >
      {props.children}
    </ContextParkingTool.Provider>
  );
};
